import { render, staticRenderFns } from "./AddFacilityDetails.vue?vue&type=template&id=bdaa6708&scoped=true"
import script from "./AddFacilityDetails.vue?vue&type=script&lang=js"
export * from "./AddFacilityDetails.vue?vue&type=script&lang=js"
import style0 from "./AddFacilityDetails.vue?vue&type=style&index=0&id=bdaa6708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaa6708",
  null
  
)

export default component.exports